import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import {
  CustomizationTabs,
  OldWidgetCustomizeFrame,
  WidgetPreviewFrame
} from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useCurrentProject } from '../../../contexts/settings';
import { useProductAgreement } from '../../../hooks';
import { RouteParams } from '../../../routes/types';

const CustomizationWidget = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { xsollaAnalytics, merchantId } = useConfig();
  const { currentProjectFetching, error, currentProject } = useCurrentProject(projectId);
  const { fetchingAgreement, isAgreementSigned } = useProductAgreement(merchantId);

  useEffect(() => {
    if (!error) {
      xsollaAnalytics.sendOpen('login_pa_module__customization_widget_open', projectId);
    }
  }, [error]);

  if (currentProjectFetching || fetchingAgreement) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError error={error} pageName="customization_widget_open" />;
  }

  if (currentProject && currentProject.widget_generation === 0) {
    return (
      <CustomizationTabs>
        <OldWidgetCustomizeFrame isAgreementSigned={isAgreementSigned} />
      </CustomizationTabs>
    );
  }

  return (
    <CustomizationTabs>
      <WidgetPreviewFrame isAgreementSigned={isAgreementSigned} />
    </CustomizationTabs>
  );
};

export default withRouter(CustomizationWidget);
